import { render } from "./NestableModal.vue?vue&type=template&id=556ca990"
import script from "./NestableModal.vue?vue&type=script&lang=js"
export * from "./NestableModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__